/**
 * CRM "МояФабрика" Version Configuration
 * Этот файл автоматически обновляется системой управления версиями
 */

export const APP_VERSION = '22.0.54';
export const APP_NAME = 'CRM "МояФабрика"';

export default {
  version: APP_VERSION,
  name: APP_NAME
};